import express, { Router } from 'express';
import {
  collectLogsHandler,
  collectLogsBatchHandler,
} from './controller';
import { resolveLogDir } from './utils';

interface RouterOptions {
  logDir?: string;
  fileName?: string;
}

// Default body size limit: 20mb, can be overridden via BODY_SIZE_LIMIT env variable (e.g., '50mb')
const DEFAULT_BODY_SIZE_LIMIT = '20mb';

function getBodySizeLimit(): string {
  return process.env.BODY_SIZE_LIMIT || DEFAULT_BODY_SIZE_LIMIT;
}

/**
 * Create dev log router with all routes registered
 */
export function createDevLogRouter(options: RouterOptions = {}): Router {
  const logDir = resolveLogDir(options.logDir);
  const router = express.Router();
  const bodyLimit = getBodySizeLimit();

  // POST /collect - Collect logs from client
  // Use express.json() middleware only for this route
  router.post('/collect', express.json({ limit: bodyLimit }), collectLogsHandler(logDir, options.fileName || 'client.log'));
  router.post('/collect-batch', express.json({ limit: bodyLimit }), collectLogsBatchHandler(logDir, options.fileName || 'client.log'));

  return router;
}
